<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default ({
  created() {
    this.$store.dispatch('getVersionId');
  },
});
</script>


<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 26px;
  color: #2c3e50;
  background-color: rgb(246, 245, 251);
  width: 100%;
  height: 100%;
}
</style>
